export const relationshipType = {
  hyperlink: 'hyperlink',
  pagelink: 'pagelink',
  modalLink: "modalLink",
  responseButton: 'responseButton',
  linkButton: 'linkButton',
  schedulerButton: 'schedulerButton',
  tabLink: 'tabLink',
}

export default {
  navigation: {
    name: 'navigation',
  },
  agents: {
    name: 'agents',
  },
  onboardingCapacity: {
    name: 'onboardingCapacity',
  },
  prevPageContent: {
    name: 'prevPageContent',
  },
  nextPageContent: {
    name: 'nextPageContent',
  },
  rowDetails: {
    name: 'rowDetails',
  },
  devOnlyMessageRouteProcessing: {
    name: 'devOnlyMessageRouteProcessing',
  },
  devOnlyCancelAllChiliPiperMeetings: {
    name: 'devOnlyCancelAllChiliPiperMeetings',
  },
  apexAccountDetailGroups: {
    name: "apexAccountDetailGroups"
  },
  goalsPage: {
    name: 'goalsPage',
  },
  roadmapDeliverableIntroWizard: {
    name: 'roadmapDeliverableIntroWizard',
  },
  addGoal: {
    name: 'addGoal',
  },
  add: {
    name: 'add',
  },
  threadRoutingDetails: {
    name: 'threadRoutingDetails',
  },
  seeValueInOtherSection: {
    name: 'seeValueInOtherSection',
  },
  gainsBudgetCalculator: {
    name: 'gainsBudgetCalculator',
  },
  previousLink: {
    name: 'previousLink',
  },
  deleteAUM: {
    name: 'deleteAUM'
  },
  confirm: {
    name: 'confirm'
  },
  previousPage: {
    name: 'previousPage',
  },
  current: {
    name: 'current',
  },
  nextLink: {
    name: 'nextLink',
  },
  planSummary: {
    name: 'planSummary',
  },
  uploadTransitionRecommendedPlannerCSV: {
    name: 'uploadTransitionRecommendedPlannerCSV'
  },
  desiredOutcomesSummaryPage: {
    name: 'desiredOutcomesSummaryPage',
  },
  selfServiceOnboarding: {
    name: 'selfServiceOnboarding'
  },
  selfServiceOnboardingWithMemberRequest: {
    name: 'selfServiceOnboardingWithMemberRequest'
  },
  conciergeOnboarding: {
    name: 'conciergeOnboarding'
  },
  updatedThreadFilterMenu: {
    name: 'updatedThreadFilterMenu'
  },
  inAppConciergeSchedule: {
    name: 'inAppConciergeSchedule'
  },
  export: {
    name: 'export',
  },
  proposalScenarioTaxStrategyDetails: {
    name: 'proposalScenarioTaxStrategyDetails'
  },
  roadmapExecutiveSummary: {
    name: 'roadmapExecutiveSummary'
  },
  previousQuestion: {
    name: 'previousQuestion',
  },
  newMembershipURL: {
    name: 'newMembershipURL',
  },
  updateModel: {
    name: 'updateModel',
  },
  recommendedPlannerProfileImage: {
    name: 'recommendedPlannerProfileImage',
  },
  updateName: {
    name: 'updateName',
  },
  routedThread: {
    name: 'routedThread',
  },
  managedAccountModelUpdateRequests: {
    name: 'managedAccountModelUpdateRequests',
  },
  errorLocation: {
    name: 'errorLocation'
  },
  goto: {
    name: 'goto',
  },
  sublink: {
    name: 'sublink',
  },
  pageRefresh: {
    name: 'pageRefresh',
  },
  eqfChat: {
    name: 'eqfChat'
  },
  waitlistScheduleChiliPiperMeeting: {
    name: 'waitlistScheduleChiliPiperMeeting',
  },
  scheduleMeetingWithPlanner: {
    name: 'scheduleMeetingWithPlanner',
  },
  scheduleMeetingWithConcierge: {
    name: 'scheduleMeetingWithConcierge'
  },
  scheduleMeetingWithMx: {
    name: 'scheduleMeetingWithMx',
  },
  equityHoldings: {
    name: 'equityHoldings',
  },
  alternativeIncomeHoldings: {
    name: 'alternativeIncomeHoldings',
  },
  fixedHoldings: {
    name: 'fixedHoldings',
  },
  addRequest: {
    name: 'addRequest',
  },
  modelPerformanceChartData: {
    name: 'modelPerformanceChartData',
  },
  modelPerformanceData: {
    name: 'modelPerformanceData',
  },
  documentUpload: {
    name: 'documentUpload',
  },
  accountOpeningTalkToSomeoneStep: {
    name: 'accountOpeningTalkToSomeoneStep',
  },
  debugAccess: {
    name: 'debugAccess',
  },
  meetings: {
    // Deprecated
    name: 'meetings',
  },
  manualMessageRouting: {
    name: 'manualMessageRouting',
  },
  meeting: {
    name: 'meeting',
  },
  meetingAgendas: {
    name: 'meetingAgendas',
  },
  meetingAgenda: {
    name: 'meetingAgenda',
  },
  trustDocument: {
    name: 'trustDocument',
  },
  trustDocuments: {
    name: 'trustDocuments',
  },
  linkTrustDocument: {
    name: 'linkTrustDocument',
  },
  linkAccountDocument: {
    name: 'linkAccountDocument',
  },
  accountDocuments: {
    name: 'accountDocuments',
  },
  sensitiveInfoSocialSecurityNumber: {
    name: 'sensitiveInfoSocialSecurityNumber',
  },
  socialSecurityBenefits: {
    name: 'socialSecurityBenefits'
  },
  legalDocuments: {
    name: 'legalDocuments',
  },
  apexDisclosures: {
    name: 'apexDisclosures'
  },
  disclaimer: {
    name: 'disclaimer'
  },
  reVerifyIdentity: {
    name: 'reVerifyIdentity'
  },
  guidedHouseholdReview: {
    name: 'guidedHouseholdReview',
  },
  guidedHouseholdReviewLayout: {
    name: 'guidedHouseholdReviewLayout',
  },
  roadmapDeliverableLayout: {
    name: 'roadmapDeliverableLayout',
  },
  pm2Journey: {
    name: 'pm2Journey',
  },
  toggleGoalsView: {
    name: 'toggleGoalsView',
  },
  viewAssumptions: {
    name: 'viewAssumptions',
  },
  makeCreditCardPaymentMethodCurrent: {
    name: 'makeCreditCardPaymentMethodCurrent'
  },
  makeAccountDebitPaymentMethodCurrent: {
    name: 'makeAccountDebitPaymentMethodCurrent'
  },
  biography: {
    name: 'biography'
  },
  removePaymentMethod: {
    name: 'removePaymentMethod'
  },
  editPaymentMethod: {
    name: 'editPaymentMethod'
  },
  editLink: {
    name: 'editLink'
  },
  groups: {
    name: 'groups',
  },
  scheduledMeetingAgendas: {
    name: 'scheduledMeetingAgendas',
  },
  scheduledUnreviewedMeetingAgendas: {
    name: 'scheduledUnreviewedMeetingAgendas',
  },
  chooseAnother: {
    name: 'chooseAnother',
  },
  homePage: {
    name: 'homePage',
  },
  hiddenNavigation: {
    name: 'hiddenNavigation',
  },
  userSettingsSecurityPageRevamp: {
    name: 'userSettingsSecurityPageRevamp'
  },
  passkeyVerification: {
    name: 'passkeyVerification'
  },
  remove: {
    name: 'remove',
  },
  authenticationFactorItems: {
    name: 'authenticationFactorItems',
  },
  roleSelection: {
    name: 'roleSelection',
  },
  userRoles: {
    name: 'userRoles',
  },
  proposalScenarioGoalStrategyOverviewSection: {
    name: 'proposalScenarioGoalStrategyOverviewSection'
  },
  scenarioQuestionForPlanner: {
    name: 'scenarioQuestionForPlanner'
  },
  devOnlySetCookie: {
    name: 'devOnlySetCookie',
  },
  devOnlyHouseholdInfo: {
    name: 'devOnlyHouseholdInfo',
  },
  devOnlyLeadCapture: {
    name: 'devOnlyLeadCapture',
  },
  householdMeetings: {
    name: 'householdMeetings',
  },
  previousHouseholdMeetings: {
    name: 'previousHouseholdMeetings',
  },
  uploadFile: {
    name: 'uploadFile'
  },
  investmentSection: {
    name: 'investmentSection',
  },
  presentsAsDownloadable: {
    name: 'presentsAsDownloadable',
  },
  claimMyUpgrade: {
    name: 'claimMyUpgrade',
  },
  upgradeNow: {
    name: 'upgradeNow',
  },
  upgradeForAmount: {
    name: 'upgradeForAmount',
  },
  planToCancel: {
    name: 'planToCancel',
  },
  dontPlanToRenew: {
    name: 'dontPlanToRenew',
  },
  andersImage: {
    name: 'andersImage',
  },
  andersSignature: {
    name: 'andersSignature',
  },
  cancelTimerImage: {
    name: 'cancelTimerImage',
  },
  digitalOnboarding: {
    name: 'digitalOnboarding',
  },
  onboardingBalanceSheet: {
    name: 'onboardingBalanceSheet',
  },
  noReplyEmails: {
    name: 'noReplyEmails',
  },
  scenarioSelectionDecisionStep: {
    name: 'scenarioSelectionDecisionStep',
  },
  nextUpRefreshStep: {
    name: 'nextUpRefreshStep',
  },
  memberActionItemPillars: {
    name: 'memberActionItemPillars',
  },
  meetingTemplates: {
    name: 'meetingTemplates',
  },
  secure: {
    name: 'secure',
  },
  transaction: {
    name: 'transaction',
  },
  sampleTransactions: {
    name: 'sampleTransactions',
  },
  missionControl: {
    name: 'missionControl',
  },
  plaidToken: {
    name: 'plaidToken',
  },
  plaidEvent: {
    name: 'plaidEvent',
  },
  financialInstitutionSuccessRate: {
    name: 'financialInstitutionSuccessRate',
  },
  consolidateInstitution: {
    name: 'consolidateInstitution',
  },
  financialInstitutionDetails: {
    name: 'financialInstitutionDetails',
  },
  syncFinicityAccounts: {
    name: 'syncFinicityAccounts',
  },
  verifyMicroDeposits: {
    name: 'devOnlyVerifyMicroDeposits',
  },
  expireMicroDeposits: {
    name: 'devOnlyExpireMicroDeposits',
  },
  notes: {
    name: 'notes',
  },
  noteHistory: {
    name: 'noteHistory',
  },
  goals: {
    name: 'goals',
  },
  files: {
    name: 'files',
  },
  homeFolder: {
    name: 'homeFolder',
  },
  segmentMessages: {
    name: 'segmentMessages',
  },
  file: {
    name: 'file',
  },
  uploadedAccountStatements: {
    name: 'uploadedAccountStatements'
  },
  folder: {
    name: 'folder'
  },
  planningVersionUpgradeResponse: {
    name: 'planningVersionUpgradeResponse'
  },
  householdSectionService: {
    name: 'householdSectionService'
  },
  householdSectionSecurity: {
    name: 'householdSectionSecurity'
  },
  householdSectionUserManagement: {
    name: 'householdSectionUserManagement',
  },
  primaryClientMfaReset: {
    name: 'primaryClientMfaReset'
  },
  primaryClientIdentityVerificationUnlock: {
    name: 'primaryClientIdentityVerificationUnlock'
  },
  modelUpdateRequestAggregatePage: {
    name: 'modelUpdateRequestAggregatePage'
  },
  secondaryClient: {
    name: 'secondaryClient'
  },
  secondaryClientMfaReset: {
    name: 'secondaryClientMfaReset'
  },
  secondaryClientIdentityVerificationUnlock: {
    name: 'secondaryClientIdentityVerificationUnlock'
  },
  userManagement: {
    name: 'userManagement',
  },
  primaryUserStatus: {
    name: 'primaryUserStatus',
  },
  secondaryUserStatus: {
    name: 'secondaryUserStatus',
  },
  openReplays: {
    name: 'openReplays'
  },
  householdSectionBilling: {
    name: 'householdSectionBilling'
  },
  householdSectionMember: {
    name: 'householdSectionMember'
  },
  parentFolder: {
    name: 'parentFolder'
  },
  download: {
    name: 'download',
  },
  icon: {
    name: 'icon',
  },
  cashflow: {
    name: 'cashFlow',
  },
  cashFlowRetirementTour: {
    name: 'cashFlowRetirementTour',
  },
  cashFlowTransactionCategoryDetails: {
    name: 'cashFlowTransactionCategoryDetails',
  },
  transactions: {
    name: 'transactions',
  },
  transactionSummary: {
    name: 'transactionSummary',
  },
  personalEmailTemplates: {
    name: 'personalEmailTemplates',
  },
  emergencyFund: {
    name: 'emergencyFund',
  },
  csm: {
    name: 'csm'
  },
  accountManagement: {
    name: 'accountManagement',
  },
  actionLink: {
    name: 'actionLink',
  },
  hideInsteadOfDelete: {
    name: 'hideInsteadOfDelete',
  },
  fixLink: {
    name: 'fixLink',
  },
  manualRefresh: {
    name: 'manualRefresh',
  },
  relink: {
    name: 'relink',
  },
  messagesRightClickMenu: {
    name: 'messagesRightClickMenu',
  },
  accountSummaries: {
    name: 'accountSummaries',
  },
  financialInstitutions: {
    name: 'financialInstitutions',
  },
  householdFinancialInstitutions: {
    name: 'householdFinancialInstitutions',
  },
  addAccount: {
    name: 'addAccount',
  },
  addManualAccount: {
    name: 'addManualAccount',
  },
  addOutcome: {
    name: 'addOutcome',
  },
  linkAccount: {
    name: 'linkAccount'
  },
  addRealAsset: {
    name: 'addRealAsset',
  },
  addBalanceTransfer: {
    name: 'addBalanceTransfer',
  },
  addBeneficiary: {
    name: 'addBeneficiary',
  },
  takingTooLong: {
    name: 'takingTooLong',
  },
  addRefinanceDebt: {
    name: 'addRefinanceDebt',
  },
  newAccountRequiredFields: {
    name: 'newAccountRequiredFields',
  },
  manuallyAddInstitution: {
    name: 'manuallyAddInstitution',
  },
  linkOrAddAccounts: {
    name: 'linkOrAddAccounts',
  },
  manualAddAccount: {
    name: 'manualAddAccount',
  },
  addRealAssetOrAccountWizard: {
    name: 'addRealAssetOrAccountWizard'
  },
  syncAccounts: {
    name: 'syncAccounts',
  },
  compare: {
    name: 'compare',
  },
  pageCompletionSummary: {
    name: 'pageCompletionSummary'
  },
  poweredBy: {
    name: 'poweredBy',
  },
  yodleeLink: {
    name: 'yodleeLink',
  },
  refresh: {
    name: 'refresh',
  },
  approval: {
    name: 'approval',
  },
  redirect: {
    name: 'redirect',
  },
  redirectOnClose: {
    name: 'redirectOnClose',
  },
  investmentSections: {
    name: 'investmentSections',
  },
  capitalizeExit: {
    name: 'capitalizeExit',
  },
  capitalizeRolloverCreated: {
    name: 'capitalizeRolloverCreated',
  },
  capitalizeRolloverCancelled: {
    name: 'capitalizeRolloverCancelled',
  },
  capitalizeRolloverSubmitted: {
    name: 'capitalizeRolloverSubmitted',
  },
  capitalizeEvent: {
    name: 'capitalizeEvent',
  },
  redirectOnExit: {
    name: 'redirectOnExit',
  },
  trust: {
    name: 'trust',
  },
  trustee: {
    name: 'trustee',
  },
  additionalTrustees: {
    name: 'additionalTrustees',
  },
  trustees: {
    name: 'trustees',
  },
  subStep: {
    name: 'subStep',
  },
  basicInformation: {
    name: 'basicInformation',
  },
  deductions: {
    name: 'deductions',
  },
  retirementContributions: {
    name: 'retirementContributions',
  },
  devOnlyYodleeInvalidateUserFixable: {
    name: 'devOnlyYodleeInvalidateUserFixable',
  },
  devOnlyYodleeInvalidateUserNonFixable: {
    name: 'devOnlyYodleeInvalidateUserNonFixable',
  },
  devOnlyFixYodleeLogin: {
    name: 'devOnlyFixYodleeLogin',
  },
  devOnlyGetYodleeProviderAccountStatus: {
    name: 'devOnlyGetYodleeProviderAccountStatus',
  },
  devOnlyAccountCreationRequest: {
    name: 'devOnlyAccountCreationRequest',
  },
  profilePage: {
    name: 'profilePage',
  },
  profilePageUnselected: {
    name: 'profilePageUnselected',
  },
  events: {
    name: 'events',
  },
  linkToken: {
    name: 'linkToken'
  },
  finicityLink: {
    name: 'finicityLink',
  },
  devOnlyProposalExpirationDate: {
    name: 'devOnlyProposalExpirationDate',
  },
  plaidLink: {
    name: 'plaidLink',
  },
  addCustomGoal: {
    name: 'addCustomGoal',
  },
  onFailure: {
    name: 'onFailure',
  },
  onSuccess: {
    name: 'onSuccess',
  },
  addManually: {
    name: 'addManually',
  },
  institution: {
    name: 'institution',
  },
  manualCreation: {
    name: 'manualCreation',
  },
  accountRequestSummaries: {
    name: 'accountRequestSummaries',
  },
  accountCreationRequest: {
    name: 'accountCreationRequest',
  },
  accountCreationRequestNoCache: {
    name: 'accountCreationRequestNoCache',
  },
  protectedResponse: {
    name: 'protectedResponse',
  },
  message: {
    name: 'message',
  },
  innerMessageResponse: {
    name: 'innerMessageResponse',
  },
  acceptFacet2Upgrade: {
    name: 'acceptFacet2Upgrade',
  },
  learnMoreAboutFacet2Upgrade: {
    name: 'learnMoreAboutFacet2Upgrade'
  },
  facet2OptIn: {
    name: 'facet2OptIn'
  },
  leadPage: {
    name: 'leadPage',
  },
  wantsScenario: {
    name: 'wantsScenario',
  },
  wantsToLearnMore: {
    name: 'wantsToLearnMore',
  },
  messages: {
    name: 'messages',
  },
  draftMessages: {
    name: 'draftMessages',
  },
  knowYourCustomerEvent: {
    name: 'knowYourCustomerEvent',
  },
  postResponseRedirect: {
    name: 'postResponseRedirect'
  },
  devOnlyAncillaryServiceAgreement: {
    name: 'devOnlyAncillaryServiceAgreement'
  },
  messagesPage: {
    name: 'messagesPage',
  },
  loginVisualUpdate: {
    name: 'loginVisualUpdate',
  },
  loginNoAuthSession: {
    name: 'loginNoAuthSession',
  },
  authRefactorNoAuthSession: {
    name: 'authRefactorNoAuthSession',
  },
  messagesContextRearchitecture: {
    name: 'messagesContextRearchitecture',
  },
  messagesOld: {
    name: 'messagesOld'
  },
  sharedNextBestNextSteps: {
    name: 'sharedNextBestNextSteps',
  },
  accounts: {
    name: 'accounts',
  },
  activePassiveIncomeCategories: {
    name: 'activePassiveIncomeCategories',
  },
  externalServiceHealthCheck: {
    name: 'externalServiceHealthCheck',
  },
  multiAccountSupportEnabled: {
    name: 'multiAccountSupportEnabled',
  },
  holdings: {
    name: 'holdings',
  },
  employeeStockOptions: {
    name: 'employeeStockOptions',
  },
  aggregatorAccounts: {
    name: 'aggregatorAccounts',
  },
  apexFundingAccounts: {
    name: 'apexFundingAccounts',
  },
  linkedApexFundingAccounts: {
    name: 'linkedApexFundingAccounts',
  },
  linkApexFundingAccount: {
    name: 'linkApexFundingAccount',
  },
  linkedInstitution: {
    name: 'linkedInstitution',
  },
  apexFundingAccountLinking: {
    name: 'apexFundingAccountLinking',
  },
  uploadDocument: {
    name: 'uploadDocument',
  },
  attachedDocuments: {
    name: 'attachedDocuments',
  },
  payStub: {
    name: 'payStub',
  },
  payStubs: {
    name: 'payStubs',
  },
  needHelp: {
    name: 'needHelp',
  },
  slackAlerts: {
    name: 'slackAlerts',
  },
  rejectReview: {
    name: 'rejectReview',
  },
  reject: {
    name: 'reject',
  },
  reopenReview: {
    name: 'reopenReview',
  },
  approveReview: {
    name: 'approveReview',
  },
  assignToMe: {
    name: 'assignToMe',
  },
  assignInOpsAgent: {
    name: 'assignInOpsAgent',
  },
  businessEvents: {
    name: 'businessEvents',
  },
  devOnlyCheckoutIndividualAccount: {
    name: 'devOnlyCheckoutIndividualAccount',
  },
  devOnlyCheckoutIndividualAccountAfterHours: {
    name: 'devOnlyCheckoutIndividualAccountAfterHours'
  },
  devOnlyCheckoutIndividualAccountWithUniqueTaxToken: {
    name: 'devOnlyCheckoutIndividualAccountWithUniqueTaxToken',
  },
  devOnlyCheckoutIndividualAccountWithPlaidDetails: {
    name: 'devOnlyCheckoutIndividualAccountWithPlaidDetails',
  },
  devOnlyGetMockedManagedAccount: {
    name: 'devOnlyGetMockedManagedAccount',
  },
  devOnlyCheckoutIndividualAccountWithPlaidDetailsAfterHours: {
    name: 'devOnlyCheckoutIndividualAccountWithPlaidDetailsAfterHours',
  },
  devOnlyCheckInIndividualAccount: {
    name: 'devOnlyCheckInIndividualAccount',
  },
  identityVerificationReviews: {
    name: 'identityVerificationReviews',
  },
  identityVerificationReview: {
    name: 'identityVerificationReview',
  },
  devOnlySyncWithAggregator: {
    name: 'devOnlySyncWithAggregator',
  },
  closeAccount: {
    name: 'closeAccount'
  },
  devOnlySyncWithAggregatorForModelAssignment: {
    name: 'devOnlySyncWithAggregatorForModelAssignment',
  },
  devOnlySyncHoldings: {
    name: 'devOnlySyncHoldings',
  },
  managedAccount: {
    name: 'managedAccount',
  },
  managedAccountOpeningItems: {
    name: 'managedAccountOpeningItems',
  },
  activationActions: {
    name: 'activationActions',
  },
  nickname: {
    name: 'nickname',
  },
  moveManagedAccountsToNewHousehold: {
    name: 'moveManagedAccountsToNewHousehold',
  },
  overrideManagedAccountHousehold: {
    name: 'overrideManagedAccountHousehold',
  },
  randomHouseholdsForComplianceExport: {
    name: 'randomHouseholdsForComplianceExport',
  },
  rolloverRecommendationQuestionnaireReport: {
    name: 'rolloverRecommendationQuestionnaireReport',
  },
  managedAccountActivity: {
    name: 'managedAccountActivity',
  },
  addAccounts: {
    name: 'addAccounts',
  },
  addAccountsDevOnly: {
    name: 'addAccountsDevOnly',
  },
  changeType: {
    name: 'changeType',
  },
  connectionsPage: {
    name: 'connectionsPage'
  },
  addConnection: {
    name: 'addConnection',
  },
  managedAccounts: {
    name: 'managedAccounts',
  },
  managedAccountDocumentsPage: {
    name: 'managedAccountDocumentsPage',
  },
  manualAccountTransfers: {
    name: 'manualAccountTransfers',
  },
  managedAccountPage: {
    name: 'managedAccountPage',
  },
  devOnlyCreateOrionAccountWithDIAccountSleeves: {
    name: 'devOnlyCreateOrionAccountWithDIAccountSleeves',
  },
  devOnlyCreateOrionAccountWithAltAccountSleeves: {
    name: 'devOnlyCreateOrionAccountWithAltAccountSleeves',
  },
  holdingsGroup: {
    name: 'holdingsGroup',
  },
  highlightedCommentary: {
    name: 'highlightedCommentary',
  },
  historicalCommentaries: {
    name: 'historicalCommentaries',
  },
  moneyFlow: {
    name: 'moneyFlow',
  },
  noteTemplates: {
    name: 'noteTemplates',
  },
  pinnedNoteTemplates: {
    name: 'pinnedNoteTemplates',
  },
  managedAccountSelectedAllocationHistory: {
    name: 'managedAccountSelectedAllocationHistory',
  },
  editHousehold: {
    name: 'editHousehold',
  },
  noItems: {
    name: 'noItems'
  },
  editIncome: {
    name: 'editIncome',
  },
  editExpenses: {
    name: 'editExpenses',
  },
  editAssets: {
    name: 'editAssets',
  },
  editLiabilities: {
    name: 'editLiabilities',
  },
  actionItem: {
    name: 'actionItem',
  },
  actionItems: {
    name: 'actionItems',
  },
  termsOfService: {
    name: 'termsOfService',
  },
  clientActionItems: {
    name: 'clientActionItems',
  },
  incompleteClientActionItems: {
    name: 'incompleteClientActionItems',
  },
  incompletePlannerActionItems: {
    name: 'incompletePlannerActionItems',
  },
  householdActionItems: {
    name: 'householdActionItems',
  },
  plannerActionItems: {
    name: 'plannerActionItems',
  },
  modalAnnouncement: {
    name: 'modalAnnouncement',
  },
  bannerAnnouncement: {
    name: 'bannerAnnouncement',
  },
  attachments: {
    name: 'attachments',
  },
  attachment: {
    name: 'attachment',
  },
  uploadAttachment: {
    name: 'uploadAttachment',
  },
  uploadWizard: {
    name: 'uploadWizard',
  },
  upload: {
    name: 'upload',
  },
  selectDocument: {
    name: 'selectDocument'
  },
  householdBalances: {
    name: 'householdBalances',
  },
  householdBalanceSheet: {
    name: 'householdBalanceSheet',
  },
  householdBalanceSheetLegacy: {
    name: 'householdBalanceSheetLegacy',
  },
  householdBalanceSheetPage: {
    name: 'householdBalanceSheetPage',
  },
  lineItem: {
    name: 'lineItem',
  },
  assets: {
    name: 'assets',
  },
  allItems: {
    name: 'allItems',
  },
  items: {
    name: 'items',
  },
  addItem: {
    name: 'addItem',
  },
  addFirstItem: {
    name: 'addFirstItem',
  },
  missingItems: {
    name: 'missingItems',
  },
  relatedItem: {
    name: 'relatedItem',
  },
  question: {
    name: 'question',
  },
  logo: {
    name: 'logo',
  },
  missionControlEditableSequenceItem: {
    name: 'missionControlEditableSequenceItem',
  },
  back: {
    name: 'back',
  },
  proposalPreviewPage: {
    name: 'proposalPreviewPage',
  },
  proposalScenarioPX: {
    name: 'proposalScenarioPX',
  },
  memberActionItems: {
    name: 'memberActionItems',
  },
  simpleActionItems: {
    name: 'simpleActionItems',
  },
  onlyLoginEmailAddress: {
    name: 'onlyLoginEmailAddress',
  },
  tasks: {
    name: 'tasks',
  },
  groupedTasks: {
    name: 'groupedTasks',
  },
  faq: {
    name: 'faq',
  },
  default: {
    name: 'default',
  },
  userPassword: {
    name: 'userPassword',
  },
  passkeyLoginChallenge: {
    name: 'passkeyLoginChallenge',
  },
  userAuthenticationSetup: {
    name: 'userAuthenticationSetup',
  },
  billingSectionRevamp: {
    name: 'billingSectionRevamp',
  },
  featureToggles: {
    name: 'featureToggles',
  },
  devOnlyCreateTestFeatureToggleGroup: {
    name: 'devOnlyCreateTestFeatureToggleGroup',
  },
  devOnlySegmentWebhook: {
    name: 'devOnlySegmentWebhook',
  },
  goalsPageAndBanner: {
    name: 'goalsPageAndBanner',
  },
  newClientNavigation: {
    name: 'newClientNavigation',
  },
  householdTransactionsWithProjections: {
    name: 'householdTransactionsWithProjections',
  },
  budget: {
    name: 'budget',
  },
  unlink: {
    name: 'unlink',
  },
  delete: {
    name: 'delete',
  },
  externalLink: {
    name: 'externalLink',
  },
  cashflowExperimental: {
    name: 'cashflowExperimental',
  },
  actionItemDraftGroup: {
    name: 'actionItemDraftGroup',
  },
  actionItemGroup: {
    name: 'actionItemGroup',
  },
  newClientDashboard: {
    name: 'newClientDashboard',
  },
  relevantAttachments: {
    name: 'relevantAttachments'
  },
  todayDashboard: {
    name: 'todayDashboard',
  },
  missionControlDeleteTemplates: {
    name: 'missionControlDeleteTemplates',
  },
  serviceLevels: {
    name: 'serviceLevels',
  },
  realAssets: {
    name: 'realAssets',
  },
  playbooks: {
    name: 'playbooks',
  },
  trendTransactions: {
    name: 'trendTransactions',
  },
  billingInformation: {
    name: 'billingInformation',
  },
  client: {
    name: 'client',
  },
  clientViewRedefined: {
    name: 'clientViewRedefined'
  },
  creatorProfileImage: {
    name: 'creatorProfileImage',
  },
  sectionNotes: {
    name: 'sectionNotes',
  },
  newInstitutionStep: {
    name: 'newInstitutionStep',
  },
  manualTransferStep: {
    name: 'manualTransferStep'
  },
  signUpSteps: {
    name: 'signUpSteps',
  },
  related: {
    name: 'related',
  },
  relatedTask: {
    name: 'relatedTask',
  },
  bulkCommunicationForErrorRecipients: {
    name: 'bulkCommunicationForErrorRecipients',
  },
  notesContextMenu: {
    name: 'notesContextMenu',
  },
  addTask: {
    name: 'addTask',
  },
  addNote: {
    name: 'addNote',
  },
  listItems: {
    name: 'listItems',
  },
  balanceSheetEditAccount: {
    name: 'balanceSheetEditAccount',
  },
  retryLink: {
    name: 'retryLink',
  },
  bestNextStepChecklist: {
    name: 'bestNextStepChecklist',
  },
  workspaces: {
    name: 'workspaces',
  },
  householdMembershipPage: {
    name: 'householdMembershipPage'
  },
  referAFriend: {
    name: 'referAFriend'
  },
  referralPage: {
    name: 'referralPage',
  },
  taxHomePage: {
    name: 'taxHomePage',
  },
  hero: {
    name: 'hero',
  },
  filingHero: {
    name: 'filingHero',
  },
  taxFilingPartnerPage: {
    name: 'taxFilingPartnerPage'
  },
  partnerUrl: {
    name: 'partnerUrl'
  },
  devOnlyEndorserAgreementPage: {
    name: 'devOnlyEndorserAgreement'
  },
  devOnlyStartKnowYourCustomerVerification: {
    name: 'devOnlyStartKnowYourCustomerVerification'
  },
  investmentOpsAction: {
    name: 'investmentOpsAction',
  },
  link: {
    name: 'link'
  },
  cancelAnyways: {
    name: 'cancelAnyways'
  },
  riskTolerance: {
    name: 'riskTolerance'
  },
  cancelMembership: {
    name: 'cancelMembership'
  },
  billingDetailsPage: {
    name: 'billingDetailsPage'
  },
  billingDetailsRenewalDate: {
    name: 'billingDetailsRenewalDate'
  },
  roadmapDeliverable: {
    name: 'roadmapDeliverable'
  },
  roadmapDeliverableChart: {
    name: 'roadmapDeliverableChart'
  },
  paymentDetailsPage: {
    name: 'paymentDetailsPage'
  },
  estatePlanningPage: {
    name: 'estatePlanningPage'
  },
  estatePlanningRecommendation: {
    name: 'estatePlanningRecommendation',
  },
  estatePlan: {
    name: 'estatePlan'
  },
  estatePlans: {
    name: 'estatePlans'
  },
  estatePlanningStatus: {
    name: 'estatePlanningStatus'
  },
  estatePlanPendings: {
    name: 'estatePlanPendings'
  },
  estatePlanMessage: {
    name: 'estatePlanMessage'
  },
  estatePlanningDiscount: {
    name: 'estatePlanningDiscount'
  },
  estatePlanningChurn: {
    name: 'estatePlanningChurn',
  },
  estatePlanningChurnCancel: {
    name: 'estatePlanningChurnCancel',
  },
  estatePlanChurns: {
    name: 'estatePlanChurns',
  },
  askMyPlanner: {
    name: 'askMyPlanner',
  },
  askAnExpert: {
    name: 'askAnExpert'
  },
  secondaryActionEstatePlanning: {
    name: 'secondaryActionEstatePlanning'
  },
  taxDiagnosticMessage: {
    name: 'taxDiagnosticMessage'
  },
  managedAccountConsentMessage: {
    name: 'managedAccountConsentMessage',
  },
  invitationLink: {
    name: 'invitationLink'
  },
  automatedPm1Pm2MeetingAgenda: {
    name: 'automatedPm1Pm2MeetingAgenda',
  },
  footerImage: {
    name: 'footerImage'
  },
  modelUpdateRequestUpdates: {
    name: 'modelUpdateRequestUpdates',
  },
  lottie: {
    name: 'lottie',
  },
  seeOtherActions: {
    name: 'seeOtherActions',
  },
  loadingLottie: {
    name: 'loadingLottie',
  },
  boostSavingsLottie: {
    name: 'boostSavingsLottie',
  },
  keepMoreLottie: {
    name: 'keepMoreLottie',
  },
  lowerTaxesLottie: {
    name: 'lowerTaxesLottie',
  },
  headerLottie: {
    name: 'headerLottie',
  },
  estatePlanProgress: {
    name: 'estatePlanProgress'
  },
  creditCardPaymentMethodPage: {
    name: 'creditCardPaymentMethodPage'
  },
  email: {
    name: 'email'
  },
  editInsight: {
    name: 'editInsight'
  },
  goalFlowToggle: {
    name: 'flow',
  },
  data: {
    name: 'data',
  },
  clientMeetingPreview: {
    name: 'clientMeetingPreview',
  },
  preview: {
    name: 'preview',
  },
  previewCurrent: {
    name: 'previewCurrent',
  },
  previewSummaryPage: {
    name: 'previewSummaryPage',
  },
  activityFeed: {
    name: 'activityFeed',
  },
  messagesBeta: {
    name: 'messagesBeta',
  },
  messagesCanary: {
    name: 'messagesCanary',
  },
  automateForMe: {
    name: 'automateForMe'
  },
  previousMeeting: {
    name: 'previousMeeting',
  },
  nextMeeting: {
    name: 'nextMeeting',
  },
  scheduledFutureMeetings: {
    name: 'scheduledFutureMeetings',
  },
  onTrack: {
    name: 'onTrack'
  },
  offTrack: {
    name: 'offTrack'
  },
  offTrackReason: {
    name: 'offTrackReason'
  },
  acknowledge: {
    name: 'acknowledge'
  },
  devOnlyAgentPermissions: {
    name: 'devOnlyAgentPermissions'
  },
  previousScheduledMeeting: {
    name: 'previousScheduledMeeting',
  },
  threads: {
    name: 'threads',
  },
  closeThread: {
    name: 'closeThread',
  },
  collapseState: {
    name: 'collapseState',
  },
  fullyExpanded: {
    name: 'fullyExpanded',
  },
  unreadThreads: {
    name: 'unreadThreads',
  },
  householdTransactions: {
    name: 'householdTransactions',
  },
  plannerProfileImageURL: {
    name: 'plannerProfileImageURL',
  },
  primaryAction: {
    name: 'primaryAction',
  },
  secondaryAction: {
    name: 'secondaryAction',
  },
  navigateSelectedItem: {
    name: 'navigateSelectedItem',
  },
  profileImage: {
    name: 'profileImage',
  },
  organizerProfileImage: {
    name: 'organizerProfileImage'
  },
  agentProfileImage: {
    name: 'agentProfileImage',
  },
  plannerProfileImage: {
    name: 'plannerProfileImage',
  },
  agent: {
    name: 'agent',
  },
  devOnlyAgentSkill: {
    name: 'devOnlyAgentSkill'
  },
  messagePlannerFromCustomInsight: {
    name: 'messagePlannerFromCustomInsight'
  },
  messagePlanner: {
    name: 'messagePlanner'
  },
  upcomingMeeting: {
    name: 'upcomingMeeting',
  },
  scheduleMeeting: {
    name: 'scheduleMeeting',
  },
  scheduleChiliPiperMeeting: {
    name: 'scheduleChiliPiperMeeting',
  },
  scheduleChiliPiperMeetingMM: {
    name: 'scheduleChilipiperMeetingMM',
  },
  scheduleChiliPiperMeetingMA: {
    name: 'scheduleChilipiperMeetingMA',
  },
  bookingScreenUpdates: {
    name: 'bookingScreenUpdates'
  },
  meetingScheduled: {
    name: 'meetingScheduled',
  },
  mxMeetingScheduled: {
    name: 'mxMeetingScheduled',
  },
  learnSite: {
    name: 'learnSite',
  },
  foundationsMarketingSite: {
    name: 'foundationsMarketingSite',
  },
  nextMeetingAvailability: {
    name: 'nextMeetingAvailability',
  },
  household: {
    name: 'household',
  },
  allowConciergeScheduleForNonAcats: {
    name: 'allowConciergeScheduleForNonAcats'
  },
  myPlanner: {
    name: 'myPlanner',
  },
  actionItemOccurrences: {
    name: 'actionItemOccurrences',
  },
  householdSummary: {
    name: 'householdSummary',
  },
  memberDataCapture: {
    name: 'memberDataCapture',
  },
  markProposalViewed: {
    name: 'markProposalViewed'
  },
  proposalExpiration: {
    name: 'proposalExpiration'
  },
  verifyData: {
    name: 'verifyData'
  },
  incomeTrackedFields: {
    name: 'incomeTrackedFields',
  },
  householdSearchResults: {
    name: 'householdSearchResults',
  },
  monotoneIcon: {
    name: 'monotoneIcon',
  },
  image: {
    name: 'image',
  },
  imageDesktop: {
    name: 'imageDesktop',
  },
  testimonialImage: {
    name: 'testimonialImage',
  },
  headerImage: {
    name: 'headerImage',
  },
  cardHeaderImage: {
    name: 'cardHeaderImage',
  },
  beginRegistration: {
    name: 'beginRegistration',
  },
  nextStepAction: {
    name: 'nextStepAction'
  },
  imageMobile: {
    name: 'imageMobile',
  },
  media: {
    name: 'media',
  },
  mobileImage: {
    name: 'mobileImage'
  },
  desktopImage: {
    name: 'desktopImage'
  },
  images: {
    name: 'images',
  },
  descriptionImage: {
    name: 'descriptionImage',
  },
  video: {
    name: 'video',
  },
  pageSelfLink: {
    name: 'pageSelfLink',
  },
  thread: {
    name: 'thread',
  },
  notifications: {
    name: 'notifications',
  },
  dashboard: {
    name: 'dashboard',
  },
  legacyDashboardImprovement: {
    name: 'legacyDashboardImprovement',
  },
  legacyDashboard: {
    name: 'legacyDashboard',
  },
  clearingHouseAccount: {
    name: 'clearingHouseAccount',
  },
  meetWithAnInvestmentSpecialist: {
    name: 'meetWithAnInvestmentSpecialist',
  },
  fundingInstructionDocument: {
    name: 'fundingInstructionDocument',
  },
  noCache: {
    name: 'noCache',
  },
  sync: {
    name: 'sync',
  },
  devOnlyRejectACHRelationship: {
    name: 'devOnlyRejectACHRelationship',
  },
  managedAccountTransactions: {
    name: 'managedAccountTransactions',
  },
  devOnlyManagedAccountTransactions: {
    name: 'devOnlyManagedAccountTransactions',
  },
  devOnlyTransactions: {
    name: 'devOnlyTransactions',
  },
  accountTransferSetup: {
    name: "accountTransferSetup"
  },
  transfers: {
    name: 'transfers',
  },
  acatTransfers: {
    name: 'acatTransfers',
  },
  acatTransfer: {
    name: 'acatTransfer',
  },
  deposits: {
    name: 'deposits',
  },
  update: {
    name: 'update'
  },
  achDeposits: {
    name: 'achDeposits',
  },
  devOnlyApexSubmission: {
    name: 'devOnlyApexSubmission',
  },
  withdrawals: {
    name: 'withdrawals',
  },
  withdrawalDevOnly: {
    name: 'withdrawalDevOnly',
  },
  achWithdrawals: {
    name: 'achWithdrawals',
  },
  achTransfer: {
    name: 'achTransfer',
  },
  scheduledAchTransfer: {
    name: 'scheduledAchTransfer',
  },
  promoTransaction: {
    name: 'promoTransaction',
  },
  promos: {
    name: 'promos',
  },
  products: {
    name: 'products',
  },
  iraContribution: {
    name: "iraContribution"
  },
  iraDistribution: {
    name: "iraDistribution"
  },
  iraContributionTotal: {
    name: "iraContributionTotal"
  },
  copyAgenda: {
    name: 'copyAgenda',
  },
  investmentsPerformance: {
    name: 'investmentsPerformance',
  },
  simpleInvestmentOpsActionItems: {
    name: 'simpleInvestmentOpsActionItems',
  },
  achRelationships: {
    name: 'achRelationships',
  },
  acatTransferWizard: {
    name: 'acatTransferWizard',
  },
  accountRolloverWizard: {
    name: 'accountRolloverWizard',
  },
  reusableAchRelationships: {
    name: 'reusableAchRelationships',
  },
  activeAchRelationships: {
    name: 'activeAchRelationships',
  },
  achRelationship: {
    name: 'achRelationship',
  },
  achFundingAccounts: {
    name: 'achFundingAccounts',
  },
  achTransfers: {
    name: 'achTransfers',
  },
  scheduledAchTransfers: {
    name: 'scheduledAchTransfers',
  },
  fundingAccount: {
    name: 'fundingAccount',
  },
  quickFundingBeta: {
    name: 'quickFundingBeta',
  },
  mcScheduler: {
    name: 'mcScheduler',
  },
  agentTodayDashboardTasks: {
    name: 'agentTodayDashboardTasks',
  },
  otherTodayDashboardTasks: {
    name: 'otherTodayDashboardTasks',
  },
  userInformation: {
    name: 'userInformation',
  },
  clients: {
    name: 'clients',
  },
  clientsWithDependents: {
    name: 'clientsWithDependents',
  },
  dependents: {
    name: 'dependents',
  },
  achInvestigations: {
    name: 'investigations',
  },
  searchResults: {
    name: 'searchResults',
  },
  meetingSummary: {
    name: 'meetingSummary',
  },
  projectedMeetings: {
    name: 'projectedMeetings',
  },
  availability: {
    name: 'availability',
  },
  avatar: {
    name: 'avatar',
  },
  buildSchedulerLink: {
    name: 'buildSchedulerLink',
  },
  newAdvisorSearchBarToggle: {
    name: 'newAdvisorSearchBarToggle',
  },
  pendingManagedAccountFormGroups: {
    name: 'pendingManagedAccountFormGroups',
  },
  unopenedAccountCreationRequests: {
    name: 'unopenedAccountCreationRequests',
  },
  unopenedApexAccountDetails: {
    name: 'unopenedApexAccountDetails',
  },
  fundingInstructions: {
    name: 'fundingInstructions',
  },
  apexAccountDetailsGroup: {
    name: 'apexAccountDetailsGroup',
  },
  apexAccountDetailsGroupItem: {
    name: 'apexAccountDetailsGroupItem',
  },
  fundingInstructionsWizard: {
    name: 'fundingInstructionsWizard',
  },
  fundingInstructionCta: {
    name: 'fundingInstructionCta',
  },
  fundingInstructionsPage: {
    name: 'fundingInstructionsPage',
  },
  accountFundingInstructions: {
    name: 'accountFundingInstructions',
  },
  markComplete: {
    name: 'markComplete',
  },
  additionalDetails: {
    name: 'additionalDetails',
  },
  statusAdditionalDetails: {
    name: 'statusAdditionalDetails'
  },
  additionalInformation: {
    name: 'additionalInformation',
  },
  additionalTransactionInformation: {
    name: 'additionalTransactionInformation',
  },
  rolloverRecommendationQuestionnaire: {
    name: 'rolloverRecommendationQuestionnaire',
  },
  rolloverRecommendationDocumentation: {
    name: 'rolloverRecommendationDocumentation',
  },
  preferredInstitutions: {
    name: 'preferredInstitutions',
  },
  generateConnectUrl: {
    name: 'generateConnectUrl',
  },
  accountDetails: {
    name: 'accountDetails',
  },
  accountApplication: {
    name: 'accountApplication',
  },
  devOnlyPlannerAccountApplications: {
    name: 'devOnlyPlannerAccountApplications',
  },
  personalInformation: {
    name: 'personalInformation',
  },
  contactInformation: {
    name: 'contactInformation',
  },
  contactSupport: {
    name: 'contactSupport',
  },
  decedentInformation: {
    name: 'decedentInformation',
  },
  employmentInformation: {
    name: 'employmentInformation',
  },
  trustedContactInformation: {
    name: 'trustedContactInformation',
  },
  beneficiaryInformation: {
    name: 'beneficiaryInformation',
  },
  agreement: {
    name: 'agreement',
  },
  trustAccount: {
    name: 'trustAccount',
  },
  beneficiaries: {
    name: 'beneficiaries',
  },
  attachPrimary3210Letter: {
    name: 'attachPrimary3210Letter',
  },
  attachSecondary3210Letter: {
    name: 'attachSecondary3210Letter',
  },
  devOnlyFundedClearingHouseIraAccount: {
    name: 'devOnlyFundedClearingHouseIraAccount',
  },
  devOnlySetupClearingHouseAccountsForCashTransfers: {
    name: 'devOnlySetupClearingHouseAccountsForCashTransfers',
  },
  devOnlySetupBackdoorRothAutomation: {
    name: 'devOnlySetupBackdoorRothAutomation',
  },
  devOnlyCreateCashJournal: {
    name: 'devOnlyCreateCashJournal',
  },
  devOnlyFundedClearingHouseAccount: {
    name: 'devOnlyFundedClearingHouseAccount',
  },
  devOnlyFundedCashAccount: {
    name: 'devOnlyFundedCashAccount',
  },
  devOnlyFundedTrustAccount: {
    name: 'devOnlyFundedTrustAccount',
  },
  devOnlyCompleteOnboarding: {
    name: 'devOnlyCompleteOnboarding',
  },
  devOnlyYodleeLinkInstitution: {
    name: 'devOnlyYodleeLinkInstitution',
  },
  devOnlyUnlockYodleeUser: {
    name: 'devOnlyUnlockYodleeUser',
  },
  thisMonthAvailabilityPeriod: {
    name: 'thisMonthAvailabilityPeriod',
  },
  projectedMeetingAvailabilityPeriod: {
    name: 'projectedMeetingAvailabilityPeriod',
  },
  availabilityPeriodClientBlock: {
    name: 'availabilityPeriodClientBlock',
  },
  fifteenMinuteAvailabilitiesForWeek: {
    name: 'fifteenMinuteAvailabilitiesForWeek',
  },
  thirtyMinuteAvailabilitiesForWeek: {
    name: 'thirtyMinuteAvailabilitiesForWeek',
  },
  fortyFiveMinuteAvailabilitiesForWeek: {
    name: 'fortyFiveMinuteAvailabilitiesForWeek',
  },
  sixtyMinuteAvailabilitiesForWeek: {
    name: 'sixtyMinuteAvailabilitiesForWeek',
  },
  fifteenMinuteAvailabilities: {
    name: 'fifteenMinuteAvailabilities',
  },
  thirtyMinuteAvailabilities: {
    name: 'thirtyMinuteAvailabilities',
  },
  fortyFiveMinuteAvailabilities: {
    name: 'fortyFiveMinuteAvailabilities',
  },
  sixtyMinuteAvailabilities: {
    name: 'sixtyMinuteAvailabilities',
  },
  accountLinkingEvents: {
    name: 'accountLinkingEvents',
  },
  threadParticipants: {
    name: 'threadParticipants',
  },
  joinThread: {
    name: 'joinThread',
  },
  addLeadPlannerToThread: {
    name: 'addLeadPlannerToThread',
  },
  templateDictionary: {
    name: 'templateDictionary',
  },
  outstandingHouseholdActionItems: {
    name: 'outstandingHouseholdActionItems',
  },
  simpleCalendarEvents: {
    name: 'simpleCalendarEvents',
  },
  addAccountCreationForm: {
    name: 'addAccountCreationForm',
  },
  onboardingNavbar: {
    name: 'onboardingNavbar',
  },
  emailMessages: {
    name: 'emailMessages',
  },
  user: {
    name: 'user',
  },
  login: {
    name: 'login',
  },
  loginExperimental: {
    name: 'loginExperimental',
  },
  logout: {
    name: 'logout',
  },
  resetPassword: {
    name: 'resetPassword',
  },
  resetPasswordExperimental: {
    name: 'resetPasswordExperimental',
  },
  newAuth2025IsStable: {
    name: 'newAuth2025IsStable',
  },
  setNewPassword: {
    name: 'setNewPassword',
  },
  syncEmail: {
    name: 'syncEmail',
  },
  reassociate: {
    name: 'reassociate',
  },
  reassociateAgenda: {
    name: 'reassociateAgenda',
  },
  sendToSecureFiles: {
    name: 'sendToSecureFiles',
  },
  calendarEvent: {
    name: 'calendarEvent',
  },
  calendarEvents: {
    name: 'calendarEvents',
  },
  endpointDefinitions: {
    name: 'endpointDefinitions',
  },
  rescheduleMeeting: {
    name: 'rescheduleMeeting',
  },
  chilipiperRescheduleLink: {
    name: 'chilipiperRescheduleLink',
  },
  linkingAttempts: {
    name: 'linkingAttempts',
  },
  managedAccountAllocation: {
    name: 'managedAccountAllocation',
  },
  managedAccountAllocationCleanup: {
    name: 'managedAccountAllocationCleanup',
  },
  managedAccountModelUpdateRequestPage: {
    name: 'managedAccountModelUpdateRequestPage',
  },
  managedAccountModelUpdateRequestsCount: {
    name: 'managedAccountModelUpdateRequestsCount',
  },
  facetPlanManagementImprovements: {
    name:'facetPlanManagementImprovements',
  },
  linkingEvents: {
    name: 'linkingEvents',
  },
  linkingAttemptNote: {
    name: 'note',
  },
  devOnlySeedLinkingEvents: {
    name: 'devOnlySeedLinkingEvents',
  },
  bulkCommunication: {
    name: 'bulkCommunication',
  },
  quizzes: { name: 'quizzes' },
  quizAdminItems: { name: 'quizAdminItems' },
  sections: { name: 'sections' },
  sectionAdminItems: { name: 'sectionAdminItems' },
  questions: { name: 'questions' },
  questionAdminItems: { name: 'questionAdminItems' },
  conditions: { name: 'conditions' },
  conditionAdminItems: { name: 'conditionAdminItems' },
  experiments: { name: 'experiments' },
  paymentPages: { name: 'paymentPages' },
  routeWhitelist: { name: 'routeWhitelist' },
  contactFormAdminItems: { name: 'contactFormAdminItems' },
  contactForms: { name: 'contactForms' },
  completedScreens: { name: 'completedScreens' },
  banners: { name: 'banners' },
  bulkCommunicationRecipients: {
    name: 'bulkCommunicationRecipients',
  },
  weekMeetingCount: {
    name: 'weekMeetingCount',
  },
  plaidLinkSessions: {
    name: 'plaidLinkSessions',
  },
  submitSupportTicket: {
    name: 'submitSupportTicket',
  },
  clientSchedulerCanary: {
    name: 'clientSchedulerCanary',
  },
  planner: {
    name: 'planner',
  },
  performanceCommentaryTimePeriodPage: {
    name: 'performanceCommentaryTimePeriodPage',
  },
  performanceCommentaryPage: {
    name: 'performanceCommentaryPage',
  },
  main: {
    name: "main",
  },
  devOnlyInvalidateLink: {
    name: "devOnlyInvalidateLink",
  },
  resetLogin: {
    name: 'resetLogin',
  },
  reactions: {
    name: 'reactions',
  },
  cashFlowPage: {
    name: 'cashFlowPage',
  },
  planPage: {
    name: 'planPage',
  },
  nmarsPage: {
    name: 'nmarsPage',
  },
  blueprint: {
    name: 'blueprint'
  },
  questionnaire: {
    name: 'questionnaire',
  },
  clientExperienceSaves: {
    name: 'clientExperienceSaves',
  },
  clientExperience: {
    name: 'clientExperience',
  },
  activityFeedMobileView: {
    name: 'activityFeedMobileView',
  },
  getSecureFiles: {
    name: 'getSecureFiles',
  },
  getStarted: {
    name: 'getStarted',
  },
  start: {
    name: 'start',
  },
  skip: {
    name: 'skip',
  },
  skipUploadConfirmationFeature: {
    name: 'skipUploadConfirmationFeature',
  },
  skipUploadConfirmation: {
    name: 'skipUploadConfirmation',
  },
  missingInformationConfirmation: {
    name: 'missingInformationConfirmation'
  },
  uploadSecureFiles: {
    name: 'uploadSecureFiles',
  },
  uploadImage: {
    name: 'uploadImage',
  },
  householdImage: {
    name: "householdImage",
  },
  addressImage: {
    name: "addressImage",
  },
  accomplishments: {
    name: 'accomplishments',
  },
  pastAccomplishments: {
    name: 'pastAccomplishments',
  },
  passkeyRegistration: {
    name: 'passkeyRegistration',
  },
  futureAccomplishments: {
    name: 'futureAccomplishments',
  },
  accomplishmentBestNextSteps: {
    name: 'accomplishmentBestNextSteps',
  },
  nextBestNextStepBestNextSteps: {
    name: 'nextBestNextStepBestNextSteps',
  },
  source: {
    name: 'source',
  },
  sourceType: {
    name: 'sourceType',
  },
  nextBestNextSteps: {
    name: 'nextBestNextSteps',
  },
  depositWizard: {
    name: 'depositWizard',
  },
  withdrawalWizard: {
    name: 'withdrawalWizard',
  },
  nonFundedAccounts: {
    name: 'nonFundedAccounts',
  },
  fundedAccounts: {
    name: 'fundedAccounts',
  },
  accountCreationRequestSummary: {
    name: 'accountCreationRequestSummary',
  },
  account: {
    name: 'account',
  },
  kycIdentityVerification: {
    name: 'kycIdentityVerification',
  },
  late2024AccountOpeningFlow: {
    name: 'late2024AccountOpeningFlow',
  },
  devOnlyRemoveLinkItem: {
    name: 'devOnlyRemoveLinkItem',
  },
  removeItem: {
    name: 'removeItem'
  },
  devOnlyAccountAggregatorMetadata: {
    name: 'devOnlyAccountAggregatorMetadata',
  },
  customAccountFundingRequests: {
    name: 'customAccountFundingRequests',
  },
  activationTest: {
    name: 'activationTest',
  },
  balanceAndAllocation: {
    name: 'balanceAndAllocation',
  },
  accountPerformance: {
    name: 'accountPerformance',
  },
  activitySummary: {
    name: 'activitySummary',
  },
  portfolio: {
    name: 'portfolio',
  },
  benchmarkedPerformance: {
    name: 'benchmarkedPerformance'
  },
  calendarEventReminder: {
    name: 'calendarEventReminder',
  },
  transcript: {
    name: 'transcript',
  },
  history: {
    name: 'history',
  },
  appliedDiscounts: {
    name: 'appliedDiscounts',
  },
  apexFormStepperBeta: {
    name: 'apexFormStepperBeta',
  },
  apexFormStepperAlpha: {
    name: 'apexFormStepperAlpha',
  },
  apexAccountOpening: {
    name: 'apexAccountOpening',
  },
  accountRequests: {
    name: 'accountRequests',
  },
  accountOpeningCanary: {
    name: 'accountOpeningCanary',
  },
  plannerAccountApplication: {
    name: 'plannerAccountApplication',
  },
  escalatedHousehold: {
    name: 'escalatedHousehold',
  },
  householdEscalation: {
    name: 'householdEscalation',
  },
  prospectHouseholdInfo: {
    name: 'prospectHouseholdInfo',
  },
  children: {
    name: 'children',
  },
  churn: {
    name: 'churn',
  },
  membership: {
    name: "membership"
  },
  memberDashboard: {
    name: "memberDashboard"
  },
  memberDemographics: {
    name: "memberDemographics"
  },
  activity: {
    name: 'activity',
  },
  serviceDetails: {
    name: 'serviceDetails',
  },
  financials: {
    name: 'financials',
  },
  myActions: {
    name: 'myActions',
  },
  teamActions: {
    name: 'teamActions',
  },
  memberActions: {
    name: 'memberActions',
  },
  devOnlyRequestChurn: {
    name: 'devOnlyRequestChurn'
  },
  requestChurn: {
    name: 'requestChurn'
  },
  requestChurnCancel: {
    name: 'requestChurnCancel'
  },
  accomplishmentNotes: {
    name: 'accomplishmentNotes',
  },

  sendSMSCode: {
    name: 'sendSMSCode',
  },
  renewalNote: {
    name: 'renewalNote',
  },
  availabilityPeriod: {
    name: 'availabilityPeriod',
  },
  draftMessage: {
    name: 'draftMessage',
  },
  composeNewMessage: {
    name: 'composeNewMessage'
  },
  devOnlyPlaybookProgress: {
    name: 'devOnlyPlaybookProgress',
  },
  latestInvoiceReceipts: {
    name: 'latestInvoiceReceipts',
  },
  invoice: {
    name: 'invoice'
  },
  invoiceLineItems: {
    name: 'invoiceLineItems'
  },
  testProtectedResourceRiskLevelLow: {
    name: 'testProtectedResourceRiskLevelLow',
  },
  testProtectedResourceRiskLevelMedium: {
    name: 'testProtectedResourceRiskLevelMedium',
  },
  testProtectedResourceRiskLevelHigh: {
    name: 'testProtectedResourceRiskLevelHigh',
  },
  householdCashFlow: {
    name: 'householdCashFlow',
  },
  bulkEditThreads: {
    name: 'bulkEditThreads',
  },
  failedInvestigations: {
    name: 'failedInvestigations',
  },
  apexAccountDetails: {
    name: 'apexAccountDetails',
  },
  apexAccountDetailsTrust: {
    name: 'apexAccountDetailsTrust',
  },
  apexAccountRetitlings: {
    name: 'apexAccountRetitlings',
  },
  modelChangeEvents: {
    name:'modelChangeEvents',
  },
  justAskMyPlanner: {
    name: 'justAskMyPlanner',
  },
  modelChangeEventsPage: {
    name:'modelChangeEventsPage',
  },
  nextScheduledMeeting: {
    name: 'nextScheduledMeeting',
  },
  cashFlowCanary: {
    name: 'cashFlowCanary',
  },
  schedulerCanary: {
    name: 'schedulerCanary',
  },
  accountsAlpha: {
    name: 'accountsAlpha',
  },
  cashFlowTransactions: {
    name: 'cashFlowTransactions',
  },
  reporting: {
    name: 'reporting'
  },
  plannerSettings: {
    name: 'plannerSettings',
  },
  messagesStats: {
    name: 'messagesStats',
  },
  householdStats: {
    name: 'householdStats',
  },
  referralLink: {
    name: 'referralLink',
  },
  referralMessage: {
    name: 'referralMessage',
  },
  showNativeShareSheet: {
    name: 'showNativeShareSheet',
  },
  addOnService: {
    name: 'addOnService',
  },
  createAddOnService: {
    name: 'createAddOnService',
  },
  attachDocumentGeneral: {
    name: 'attachDocumentGeneral',
  },
  attachDocumentPrimaryIncome: {
    name: 'attachDocumentPrimaryIncome',
  },
  attachDocumentOtherIncome: {
    name: 'attachDocumentOtherIncome',
  },
  attachDocumentOther: {
    name: 'attachDocumentOther',
  },
  attachDocumentExpenses: {
    name: 'attachDocumentExpenses',
  },
  expenseCategories: {
    name: 'expenseCategories',
  },
  expenses: {
    name: 'expenses',
  },
  documents: {
    name: 'documents',
  },
  taxFilingDocument: {
    name: 'taxFilingDocument',
  },
  taxFiling: {
    name: 'taxFiling',
  },
  devOnlyTaxFilingPending: {
    name: 'devOnlyTaxFilingPending',
  },
  taxFilingType: {
    name: 'taxFilingType',
  },
  taxFilingSituation: {
    name: 'taxFilingSituation',
  },
  taxFilingBackgroundInfo: {
    name: 'taxFilingBackgroundInfo',
  },
  messageTemplates: {
    name: 'messageTemplates',
  },
  pinnedMessageTemplates: {
    name: 'pinnedMessageTemplates',
  },
  outOfOfficeTemplates: {
    name: 'outOfOfficeTemplates',
  },
  pinnedOutOfOfficeTemplates: {
    name: 'pinnedOutOfOfficeTemplates',
  },
  taxFilingQuestionnaire: {
    name: 'taxFilingQuestionnaire',
  },
  taxFilingSteps: {
    name: 'taxFilingSteps',
  },
  taxFilingDependents: {
    name: 'taxFilingDependents',
  },
  integrationRaptorAccounts: {
    name: 'integrationRaptorAccounts',
  },
  incomeDetails: {
    name: 'incomeDetails',
  },
  exit: {
    name: 'exit',
  },
  exitFromRoadmapDeliverable: {
    name: 'exitFromRoadmapDeliverable',
  },
  details: {
    name: 'details',
  },
  showDetails: {
    name: 'showDetails'
  },
  proposalScenarioGoalStrategyDetails: {
    name: 'proposalScenarioGoalStrategyDetails'
  },
  toggleDisable: {
    name: 'toggleDisable',
  },
  detailItem: {
    name: 'detailItem',
  },
  navigate: {
    name: 'navigate',
  },
  navigateInternal: {
    name: 'navigateInternal',
  },
  navigateAway: {
    name: 'navigateAway'
  },
  detailNavigate: {
    name: 'detailNavigate',
  },
  experimentalUserInterface: {
    name: 'experimentalUserInterface',
  },
  availabilityForWeek: {
    name: 'availabilityForWeek',
  },
  scheduleCalendarEvent: {
    name: 'scheduleCalendarEvent',
  },
  rescheduleAvailabilityPeriod: {
    name: 'rescheduleAvailabilityPeriod',
  },
  currentMonthAvailabilityPeriod: {
    name: 'currentMonthAvailabilityPeriod',
  },
  outOfOffice: {
    name: 'outOfOffice',
  },
  investmentKnowledgeAssessment: {
    name: 'investmentKnowledgeAssessment',
  },
  improvedAccountExperienceBeta: {
    name: 'improvedAccountExperienceBeta',
  },
  statements: {
    name: 'statements',
  },
  reminders: {
    name: 'reminders',
  },
  taxDocuments: {
    name: 'taxDocuments',
  },
  userFeedback: {
    name: 'userFeedback',
  },
  tradeConfirmationDocuments: {
    name: 'tradeConfirmationDocuments',
  },
  pinnedMeetingTemplates: {
    name: 'pinnedMeetingTemplates',
  },
  emailAddresses: {
    name: 'emailAddresses',
  },
  emailAddress: {
    name: 'emailAddress',
  },
  emailAddressesWithGenerated: {
    name: 'emailAddressesWithGenerated',
  },
  authnEmail: {
    name: 'authnEmail',
  },
  address: {
    name: 'address',
  },
  templates: {
    name: 'templates',
  },
  allScheduledMessages: {
    name: 'allScheduledMessages',
  },
  userInfo: {
    name: 'userInfo',
  },
  curatedContentArticles: {
    name: 'curatedContentArticles',
  },
  onboardingContent: {
    name: 'onboardingContent',
  },
  nextOnboardingStep: {
    name: 'nextOnboardingStep',
  },
  devOnlyNextOnboardingStep: {
    name: 'devOnlyNextOnboardingStep',
  },
  clientDashboard: {
    name: 'clientDashboard',
  },
  pricingPage: {
    name: 'pricingPage',
  },
  foundationalOnly: {
    name: 'foundationalOnly',
  },
  onboardingNavigation: {
    name: 'onboardingNavigation',
  },
  onboardingChat: {
    name: 'onboardingChat',
  },
  onboardingChatWeb2Case: {
    name: 'onboardingChatWeb2Case',
  },
  newItem: {
    name: 'newItem',
  },
  segmentWebhook: {
    name: 'segmentWebhook',
  },
  allNotes: {
    name: 'allNotes',
  },
  onboardingPlannerView: {
    name: 'onboardingPlannerView',
  },
  generatedAvailabilityPeriodLink: {
    name: 'generatedAvailabilityPeriodLink',
  },
  noManualRollover: {
    name: 'noManualRollover',
  },
  outgoingBulkCommunications: {
    name: 'outgoingBulkCommunications',
  },
  households: {
    name: "households",
  },
  bulkCommunicationSummary: {
    name: 'bulkCommunicationSummary',
  },
  bulkCommunicationPreview: {
    name: 'bulkCommunicationPreview',
  },
  iterateMaster: {
    name: 'iterateMaster',
  },
  accountCustodian: {
    name: 'accountCustodian',
  },
  individual: {
    name: 'individual',
  },
  joint: {
    name: 'joint',
  },
  custodial: {
    name: 'custodial',
  },
  rothIRA: {
    name: 'rothIRA',
  },
  inheritedRoth: {
    name: 'inheritedRoth',
  },
  sepIRA: {
    name: 'sepIRA',
  },
  rolloverIRA: {
    name: 'rolloverIRA',
  },
  traditionalIRA: {
    name: 'traditionalIRA',
  },
  inheritedTraditionalIRA: {
    name: 'inheritedTraditionalIRA',
  },
  apexAccountApplication: {
    name: 'apexAccountApplication',
  },
  personalTrust: {
    name: 'personalTrust',
  },
  hasDigitalOnboarding: {
    name: 'hasDigitalOnboarding',
  },
  resendCode: {
    name: 'resendCode',
  },
  devOnlyGetUserTwoFactorVerificationCode: {
    name: 'devOnlyGetUserTwoFactorVerificationCode',
  },
  notificationPreference: {
    name: 'notificationPreference',
  },
  scheduleNewMeeting: {
    name: 'scheduleNewMeeting',
  },
  householdPlans: {
    name: 'householdPlans',
  },
  planMessage: {
    name: 'planMessage',
  },
  createEmailMessage: {
    name: 'createEmailMessage',
  },
  nextSixConfirmedMeetings: {
    name: 'nextSixConfirmedMeetings',
  },
  previousFiveConfirmedMeetings: {
    name: 'previousFiveConfirmedMeetings',
  },
  justWin: {
    name: 'justWin',
  },
  justWinPM1: {
    name: 'justWinPM1',
  },
  justWinPM2: {
    name: 'justWinPM2',
  },
  schedulerAgents: {
    name: 'schedulerAgents',
  },
  agentAvailabilityPeriod: {
    name: 'agentAvailabilityPeriod',
  },
  externalRecipients: {
    name: 'externalRecipients',
  },
  resendMfaChallenge: {
    name: 'resendMfaChallenge',
  },
  mfaChallengeCancelConfirmation: {
    name: 'mfaChallengeCancelConfirmation',
  },
  currentMfaChallenge: {
    name: 'currentMfaChallenge',
  },
  facetPlanCommentThreads: {
    name: 'facetPlanCommentThreads',
  },
  facetIcon: {
    name: 'facetIcon',
  },
  facetPlan: {
    name: 'facetPlan',
  },
  facetPlans: {
    name: 'facetPlans',
  },
  facetPlanDuplicate: {
    name: 'duplicate',
  },
  newPath: {
    name: 'newPath',
  },
  activate: {
    name: 'activate',
  },
  devOnlyPublishFacetPlan: {
    name: 'devOnlyPublishFacetPlan',
  },
  activeFacetPlanView: {
    name: 'activeFacetPlanView',
  },
  devOnlyMfaChallenges: {
    name: 'devOnlyMfaChallenges',
  },
  netsuiteIntegration: {
    name: 'netsuiteIntegrationFeature',
  },
  assumptionsAndDetails: {
    name: 'assumptionsAndDetails',
  },
  detailedSummary: {
    name: 'detailedSummary',
  },
  investingDetails: {
    name: 'investingDetails'
  },
  assumptions: {
    name: 'assumptions',
  },
  charts: {
    name: 'charts'
  },
  facetPlanAssumptions: {
    name: 'facetPlanAssumptions',
  },
  facetPlanAssumptionByDate: {
    name: 'facetPlanAssumptionByDate',
  },
  generalSavingsOutcomeWizard: {
    name: 'generalSavingsOutcomeWizard',
  },
  clientProfileHighRiskToggle: {
    name: 'clientProfileHighRiskToggle',
  },
  scheduleNextMeeting: {
    name: 'scheduleNextMeeting',
  },
  facetPlanEvents: {
    name: 'facetPlanEvents',
  },
  devOnlyAnnualInvestmentReview: {
    name: 'devOnlyAnnualInvestmentReview',
  },
  annualInvestmentReview: {
    name: 'annualInvestmentReview',
  },
  annualInvestmentReviewProgress: {
    name: 'annualInvestmentReviewProgress',
  },
  accountOpeningStartPage: {
    name: 'accountOpeningStartPage',
  },
  statusBanners: {
    name: 'statusBanners',
  },
  devOnlyInvestmentProfileProgress: {
    name: 'devOnlyInvestmentProfileProgress',
  },
  setupWizard: {
    name: 'setupWizard',
  },
  expenseCategoryGroups: {
    name: 'expenseCategoryGroups',
  },
  recommendations: {
    name: 'recommendations',
  },
  facetPlanLinterRuleResults: {
    name: 'facetPlanLinterRuleResults',
  },
  outcomeAccountSelection: {
    name: 'outcomeAccountSelection',
  },
  facetPlanOutcomeWizardNavigation: {
    name: 'facetPlanOutcomeWizardNavigation',
  },
  accountToLink: {
    name: 'accountToLink',
  },
  facetPlanStrategyWizardNavigation: {
    name: 'facetPlanStrategyWizardNavigation',
  },
  strategySetup: {
    name: 'strategySetup',
  },
  facetPlanOutcomes: {
    name: 'facetPlanOutcomes',
  },
  isLatestFacetPlanArchiveSaved: {
    name: 'isLatestFacetPlanArchiveSaved',
  },
  facetPlanOutcomeSummary: {
    name: 'facetPlanOutcomeSummary',
  },
  modalSelfLink: {
    name: 'modalSelfLink',
  },
  markReviewed: {
    name: 'markReviewed',
  },
  wizard: {
    name: 'wizard',
  },
  totpSettings: {
    name: 'totpSettings',
  },
  totpRegistration: {
    name: 'totpRegistration',
  },
  getTotpRegistrationCode: {
    name: 'getTotpRegistrationCode',
  },
  getTotpRegistrationCodeFromAuthSession: {
    name: 'getTotpRegistrationCodeFromAuthSession',
  },
  featureToggleHierarchy: {
    name: 'featureToggleHierarchy',
  },
  wellnessQuizAdministration: {
    name: 'wellnessQuizAdministration',
  },
  eqfQuiz: {
    name: 'eqfQuiz',
  },
  settingsSectionSecurity: {
    name: 'settingsSectionSecurity',
  },
  learnMore: {
    name: 'learnMore'
  },
  settingsSectionSupport: {
    name: 'settingsSectionSupport',
  },
  authenticationFactor: {
    name: 'authenticationFactor',
  },
  onboardingOptionalMfa: {
    name: 'onboardingOptionalMfa',
  },
  onboardingMFARequired: {
    name: 'onboardingMFARequired',
  },
  authenticationFactorRegister: {
    name: 'authenticationFactorRegister',
  },
  authenticationFactorModify: {
    name: 'authenticationFactorModify',
  },
  runAnalysis: {
    name: 'runAnalysis',
  },
  saveAndGenerateTaxDetails: {
    name: 'saveAndGenerateTaxDetails',
  },
  facetPlanChartData: {
    name: 'facetPlanChartData',
  },
  facetPlanChartPresentData: {
    name: 'facetPlanChartPresentData',
  },
  facetPlanMultiChartData: {
    name: 'facetPlanMultiChartData',
  },
  strategies: {
    name: 'strategies',
  },
  strategyFlow: {
    name: 'strategyFlow',
  },
  facetPlanVirtualAccounts: {
    name: 'facetPlanVirtualAccounts',
  },
  facetPlanVirtualAccount: {
    name: 'facetPlanVirtualAccount',
  },
  facetPlanView: {
    name: 'facetPlanView',
  },
  facetPlanViewWithLinterRun: {
    name: 'facetPlanViewWithLinterRun',
  },
  devOnlyFacetPlanUpdateVirtualAccounts: {
    name: 'devOnlyFacetPlanUpdateVirtualAccounts',
  },
  insights: {
    name: 'insights',
  },
  insightAdminItems: { name: 'insightAdminItems' },
  toggleCommonInsights: {
    name: 'toggleCommonInsights',
  },
  facetPlanClientView: {
    name: 'facetPlanClientView',
  },
  facetPlanProposalScenarioNextUpItems: {
    name: 'facetPlanProposalScenarioNextUpItems',
  },
  facetPlanViewAddOutcome: {
    name: 'addOutcome',
  },
  plannerTransitionSegmentKey: {
    name: 'plannerTransitionSegmentKey'
  },
  facetPlanVirtualAccountOutcomeConfigurationWizard: {
    name: 'facetPlanVirtualAccountOutcomeConfigurationWizard',
  },
  facetPlanViewDuplicatePlan: {
    name: 'duplicateFacetPlan',
  },
  selectScenario: {
    name: 'selectScenario',
  },
  bookLater: {
    name: 'bookLater',
  },
  bookNow: {
    name: 'bookNow',
  },
  noModelAssignedItems: {
    name: 'noModelAssignedItems',
  },
  modelDoesNotMatchItems: {
    name: 'modelDoesNotMatchItems',
  },
  inTradingItems: {
    name: 'inTradingItems',
  },
  facetPlanViewUpdatePlan: {
    name: 'updateFacetPlan',
  },
  clickToSync: {
    name: 'clickToSync',
  },
  scenarioChangeReview: {
    name: 'scenarioChangeReview',
  },
  facetPlanSummary: {
    name: 'facetPlanSummary',
  },
  addEmptyItem: {
    name: 'addEmptyItem',
  },
  addStrategy: {
    name: 'addStrategy',
  },
  proposalProjectionSection: {
    name: 'proposalProjectionSection',
  },
  proposalYearAheadOutflowSection: {
    name: 'proposalYearAheadOutflowSection',
  },
  proposalYearAheadInflowSection: {
    name: 'proposalYearAheadInflowSection',
  },
  proposalYearAheadMoneyFlowSection: {
    name: 'proposalYearAheadMoneyFlowSection'
  },
  proposalYearAheadMilestoneSection: {
    name: 'proposalYearAheadMilestoneSection'
  },
  valueIsCorrect: {
    name: 'valueIsCorrect',
  },
  lowerPriority: {
    name: 'lowerPriority',
  },
  raisePriority: {
    name: 'raisePriority',
  },
  item: {
    name: 'item',
  },
  generatedView: {
    name: 'generatedView',
  },
  dataFreshnessFieldsPage: {
    name: 'dataFreshnessFieldsPage',
  },
  clientView: {
    name: 'clientView',
  },
  outcomeSummary: {
    name: 'outcomeSummary',
  },
  outcomeAccountsAggregatedBreakdown: {
    name: 'outcomeAccountsAggregatedBreakdown',
  },
  outcomeAccountsBreakdown: {
    name: 'outcomeAccountsBreakdown',
  },
  addWizard: {
    name: 'addWizard',
  },
  addIncome: {
    name: 'addIncome',
  },
  addJob: {
    name: 'addJob',
  },
  addHouseholdMember: {
    name: 'addHouseholdMember',
  },
  generalFAQ: {
    name: 'generalFAQ',
  },
  taxFormsFAQ: {
    name: 'taxFormsFAQ',
  },
  plannerTransitionHousehold: {
    name: 'plannerTransitionHousehold',
  },
  plannerTransitionHouseholdSummary: {
    name: 'plannerTransitionHouseholdSummary',
  },
  plannerTransitionHouseholdsPage: {
    name: 'plannerTransitionHouseholdsPage',
  },
  plannerTransition: {
    name: 'plannerTransition',
  },
  agentUserInfo: {
    name: 'agentUserInfo',
  },
  transitionsDashboardPage: {
    name: 'transitionsDashboardPage'
  },
  taxDiagnosticPage: {
    name: 'taxDiagnosticPage'
  },
  taxDiagnosticMemberWizard: {
    name: 'taxDiagnosticMemberWizard'
  },
  investorProfilePage: {
    name: 'investorProfilePage'
  },
  transitionsDashboardHouseholdInfo: {
    name: 'transitionsDashboardHouseholdInfo'
  },
  transitionsDashboardPageAdvice: {
    name: 'transitionsDashboardPageAdvice'
  },
  templateManagerPage: {
    name: 'templateManagerPage'
  },
  addExpense: {
    name: 'addExpense',
  },
  googleCalendarEvents: {
    name: 'googleCalendarEvents',
  },
  doProgressView: {
    name: 'doProgressView',
  },
  scenarioSelectionRedefinedWizard: {
    name: 'scenarioSelectionRedefinedWizard'
  },
  reviewScenarios: {
    name: 'reviewScenarios'
  },
  continue: {
    name: 'continue'
  },
  view: {
    name: 'view',
  },
  select: {
    name: 'select',
  },
  taskStatusView: {
    name: 'taskStatusView',
  },
  firstWinView: {
    name: 'firstWinView',
  },
  scenarioReviewWizard: {
    name: 'scenarioReviewWizard',
  },
  facetPlanProposalScenarioSelectionIntroPage: {
    name: 'facetPlanProposalScenarioSelectionIntroPage'
  },
  roadmapExecutiveSummaryIntroPage: {
    name: 'roadmapExecutiveSummaryIntroPage'
  },
  scenarioSelectionRedefinedPostSelectionModule: {
    name: 'scenarioSelectionRedefinedPostSelectionModule'
  },
  reviewScenario: {
    name: 'reviewScenario'
  },
  accountOpeningWizard: {
    name: 'accountOpeningWizard',
  },
  accountRetitlingWizard: {
    name: 'accountRetitlingWizard',
  },
  guidedReview: {
    name: 'guidedReview'
  },
  actionsList: {
    name: 'actionsList'
  },
  restart: {
    name: 'restart',
  },
  interestedInWealthDotCom: {
    name: 'interestedInWealthDotCom',
  },
  notInterestedInWealthDotCom: {
    name: 'notInterestedInWealthDotCom',
  },
  CIPWizard: {
    name: 'CIPWizard'
  },
  unvalidatedScenario: {
    name: 'unvalidatedScenario'
  },
  paymentChangeView: {
    name: 'paymentChangeView',
  },
  linkedAccountErrorView: {
    name: 'linkedAccountErrorView',
  },
  tabData: {
    name: 'tabData',
  },
  newTabData: {
    name: 'newTabData',
  },
  facetPlanProposalPreviewRedefinedContent: {
    name: 'facetPlanProposalPreviewRedefinedContent'
  },
  householdNextAction: {
    name: 'householdNextAction',
  },
  plannerGuide: {
    name: 'plannerGuide'
  },
  scenarioReview: {
    name: 'scenarioReview',
  },
  additionalOutcomes: {
    name: 'additionalOutcomes'
  },
  scenariosPage: {
    name: 'scenariosPage',
  },
  outcomeSummaryDetails: {
    name: 'outcomeSummaryDetails',
  },
  cfpInsights: {
    name: 'cfpInsights',
  },
  activeScenarioChartData: {
    name: 'ActiveScenarioChartData',
  },
  sendCalendarEventReminders: {
    name: 'sendCalendarEventReminders',
  },
  simpleActionItemLinks: {
    name: 'simpleActionItemLinks',
  },
  aumHouseholdView: {
    name: 'aumHouseholdView',
  },
  aumApexAccountDetails: {
    name: 'aumApexAccountDetails',
  },
  activateFacetPlan: {
    name: 'activateFacetPlan',
  },
  activeFacetPlanScenario: {
    name: 'activeFacetPlanScenario',
  },
  activationConfirmation: {
    name: 'activationConfirmation',
  },
  mfaPreference: {
    name: 'mfaPreference',
  },
  authMagicLink: {
    name: 'authMagicLink',
  },
  authMagicLinkExperimental: {
    name: 'authMagicLinkExperimental',
  },
  plaidErrorSupport: {
    name: 'plaidErrorSupport',
  },
  mfaResetLink: {
    name: 'mfaResetLink',
  },
  mfaPreferenceSms: {
    name: "mfaPreferenceSms",
  },
  mfaPreferenceTotp: {
    name: "mfaPreferenceTotp",
  },
  specificPageLink: {
    name: 'specificPageLink'
  },
  specificThreadLink: {
    name: "specificThreadLink"
  },
  relatedMessage: {
    name: "relatedMessage"
  },
  threadHistory: {
    name: "threadHistory"
  },
  assignToAgent: {
    name: 'assignToAgent',
  },
  planningAgreementToken: {
    name: 'planningAgreementToken'
  },
  originalThread: {
    name: 'originalThread',
  },
  editContingentBeneficiaries: {
    name: 'editContingentBeneficiaries'
  },
  editPrimaryBeneficiaries: {
    name: 'editPrimaryBeneficiaries'
  },
  clientDisclaimer: {
    name: 'clientDisclaimer'
  },
  clientScenarioDisclaimer: {
    name: 'clientScenarioDisclaimer'
  },
  openAccount: {
    name: 'openAccount',
  },
  activeProposal: {
    name: 'activeProposal',
  },
  devOnlyInvalidInformation: {
    name: 'devOnlyInvalidInformation'
  },
  membershipPageRefactor: {
    name: 'membershipPageRefactor',
  },
  autoAllocateOutcome: {
    name: 'autoAllocateOutcome'
  },
  virtualAccounts: {
    name: 'virtualAccounts'
  },
  fundingTasks: {
    name: 'fundingTasks',
  },
  transferWizard: {
    name: 'transferWizard',
  },
  outcomeQuickEdit: {
    name: 'outcomeQuickEdit',
  },
  logs: {
    name: 'logs'
  },
  effects: {
    name: 'effects'
  },
  differences: {
    name: 'differences'
  },
  callSummaries: {
    name: 'callSummaries',
  },
  nextUpDetails: {
    name: 'nextUpDetails'
  },
  facetPlanSmartAllocationSteps: {
    name: 'facetPlanSmartAllocationSteps',
  },
  facetPlanSmartAllocationCustomization: {
    name: 'facetPlanSmartAllocationCustomization',
  },
  reset: {
    name: 'reset',
  },
  lexorank: {
    name: 'lexorank',
  },
  directIndexingPersonInfo: {
    name: 'directIndexingPersonInfo',
  },
  devOnlyDuplicateFacetPlanFromArchive: {
    name: 'devOnlyDuplicateFacetPlanFromArchive',
  },
  nextUpReviewPage: {
    name: 'nextUpReviewPage',
  },
  devOnlyFacetPlanStartDate: {
    name: 'devOnlyFacetPlanStartDate',
  },
  nextUpSummary: {
    name: 'nextUpSummary',
  },
  nextUpSummaryTimeline: {
    name: 'nextUpSummaryTimeline',
  },
  smartScenarioInsights: {
    name: 'smartScenarioInsights',
  },
  addInsights: {
    name: 'addInsights',
  },
  proposalPreviewDataForScenarioSelectionRedefined: {
    name: 'proposalPreviewDataForScenarioSelectionRedefined'
  },
  devOnlyAppAnnouncement: {
    name: 'devOnlyAppAnnouncement'
  },
  devOnlySendMemberDataCaptureMessages: {
    name: 'devOnlySendMemberDataCaptureMessages'
  },
  devOnlyAllSegmentMessages: {
    name: 'devOnlyAllSegmentMessages'
  },
  devOnlyExpireLeadsWebhook: {
    name: 'devOnlyExpireLeadsWebhook'
  },
  devOnlyMemberRequests: {
    name: 'devOnlyMemberRequests'
  },
  addAssumptionEntry: {
    name: 'addAssumptionEntry'
  },
  resources: {
    name: 'resources'
  },
  jobs: {
    name: 'jobs',
  },
  edit: {
    name: 'edit',
  },
  willDeleteExistingActionItems: {
    name: 'willDeleteExistingActionItems'
  },
  automationOptions: {
    name: 'automationOptions'
  },
  refinanceDebtGroupLoanOffer: {
    name: 'refinanceDebtGroupLoanOffer'
  },
  webview: {
    name: 'webview',
  },
  mainContentImage: {
    name: 'mainContentImage',
  },
  manualRollover: {
    name: 'manualRollover',
  },
  accountDebitEnrollment: {
    name: 'accountDebitEnrollment',
  },
  transferLottieHorizontal: {
    name: 'transferLottieHorizontal',
  },
  transferLottieVertical: {
    name: 'transferLottieVertical',
  },
  scenarioDetails: {
    name: 'scenarioDetails'
  },
  run: {
    name: 'run',
  },
  retirementAgeWizard: {
    name: 'retirementAgeWizard',
  },
  startOver: {
    name: 'startOver',
  },
  altAllocationMessage: {
    name: 'altAllocationMessage',
  },
  influencerHeadshot: {
    name: 'influencerHeadshot',
  },
  newYorkTimesLogo: {
    name: 'newYorkTimesLogo',
  },
  businessInsiderLogo: {
    name: 'businessInsiderLogo',
  },
  forbesLogo: {
    name: 'forbesLogo',
  },
  wallStreetJournalLogo: {
    name: 'wallStreetJournalLogo',
  },
  videoThumbnail: {
    name: 'videoThumbnail',
  },
  usaTodayBadge: {
    name: 'usaTodayBadge',
  },
  levers: {
    name: 'levers',
  },
  managePaths: {
    name: 'managePaths',
  },
};
